// extracted by mini-css-extract-plugin
export var trailerHolder = "Trailer-module--trailerHolder--eCkxh";